// dependencies.
import styled from 'styled-components'
// components.
import { Body } from '../Typography'
import { Input } from '../Form'
// utils.
import { useDimensions } from '../../js/hooks'

/************************/
/*                      */
/*    Search Heading    */
/*                      */
/************************/

// partials.
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: (props) => (props.isTablet ? '8px' : '16px'),
  width: (props) => (props.column ? '100%' : 'fit-content'),
})

// main component.
const FilterResponsible = ({
  label,
  responsibles,
  onResponsibleFilter = () => {},
  placeholder = 'Responsable',
}) => {
  // contexts.
  // hooks.
  const { isMobile, isTablet } = useDimensions()

  const optionLabels = responsibles.map(({ label, name }, i) => ({
    name: name,
    label: label,
  }))

  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //
  // return content.
  return (
    <Wrapper column={!!label} isTablet={isTablet}>
      {label && (
        <Body type="caption" color="grey">
          {label}
        </Body>
      )}
      <Input
        isMobile={isMobile}
        options={optionLabels}
        name="status"
        iconL="user"
        placeholder={placeholder}
        onChange={(e) => onResponsibleFilter(e)}
      />
    </Wrapper>
  )
}

export default FilterResponsible
